// Removed unused individual race exports

import { human } from "./human";
import { elf } from "./elf";
import { dwarf } from "./dwarf";
import { halfling } from "./halfling";
import { dokkalfar } from "./dokkalfar";
import { gnome } from "./gnome";
import { halfElf } from "./half-elf";
import { halfOgre } from "./half-ogre";
import { halfOrc } from "./half-orc";
import { bisren } from "./bisren";
import { canein } from "./canein";
import { chelonian } from "./chelonian";
import { faun } from "./faun";
import { phaerim } from "./phaerim";

export const allRaces = [
  human,
  elf,
  dwarf,
  halfling,
  dokkalfar,
  gnome,
  halfElf,
  halfOgre,
  halfOrc,
  bisren,
  canein,
  chelonian,
  faun,
  phaerim,
];
